const debounce = (func, delay) => {
  let debounceTimer;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

/**
 * Custom error message for already subscribed users
 */
const catchAlreadySubscribedError = () => {
  const LIVE_URL = window.location.href;
  
  const inputVal = document.querySelector('[name="contact[email]"').value.length;
  const result = LIVE_URL.includes('form_type=customer');
  const responseDiv = document.querySelector('[data-already-subscribed]');
  
  if (result && inputVal != 0) {
    responseDiv.hidden = false;
  }
}

/**
 * Custom select field for newsletter
 */
const addCustomNewsletterFieldsAsTags = () => {
  const newsletterTagFields = [...document.querySelectorAll('[name="contact[tags]"]')];
  
  newsletterTagFields.forEach(tagField => {
    const form = tagField.closest('form');
    const customFields = [...form.querySelectorAll('[name*="custom_field"]')];

    customFields.forEach(field => {
      field.addEventListener('change', debounce((e) => {
        const fieldName = e.target.name;
        const fieldValue = e.target.value;
        
        let tags = tagField.value.split(',');
        const existingTagIndex = tags.findIndex(tag => tag.startsWith(`${fieldName}=`));
        
        if (existingTagIndex !== -1) {
          tags[existingTagIndex] = `${fieldName}=${fieldValue}`;
        } else {
          tags.push(`${fieldName}=${fieldValue}`);
        }
        
        tagField.value = tags.join(',');
        }, 300));
    });
  });
}
  
document.addEventListener('DOMContentLoaded', function() {
  catchAlreadySubscribedError();
  addCustomNewsletterFieldsAsTags();
});